export default __webpack_public_path__ + "images/graphics/eco-friendly-stamp-sv.png";